var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"containers-fluid wow fadeIn main_index_landing"},[_c('banner'),_c('cards'),_c('parallax')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }